module.exports = __webpack_public_path__ + "static/media/A4Labels24.74ff3049.png";